import React from 'react';
import { Typography } from '@guildeducationinc/recess';
import { HighlightPopover } from '../HighlightPopover';
import styles from './DeferredPopover.module.scss';

export const DeferredPopover: React.FC = () => {
	const displayCopy = "Why can't I start this program now?";
	const popoverContent =
		"This program offered through your education benefit has reached the maximum number of students for this term. But don't worry - just submit an early application for the next available start date.";

	return (
		<div className={styles.wrapper}>
			<Typography className={styles.message} variant='label1'>
				{displayCopy}
			</Typography>
			<HighlightPopover
				eventText={displayCopy}
				id='deferred'
				popoverContent={popoverContent}
				popoverLabel='More info about deferred availability'
			/>
		</div>
	);
};
